import React, { useCallback, useEffect, useState } from 'react';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import {faChevronDown, faChevronRight, faPlus} from '@fortawesome/fontawesome-free-solid';
import i18next from 'i18next';

import { TextInput } from '../TextInput';
import { SelectInput } from '../SelectInput';

import config from "config";

const ChecklistTaskGroupHeader = ({ readOnly, expanded, taskGroup, onAddTaskToGroup, onTaskGroupRemove, onExpandedChange }) => {
    const taskGroupName = `${i18next.t('pages.checklists.task-group')} ${expanded ? '' : `: ${taskGroup.name}`}`;
    const chevron = expanded ? faChevronDown : faChevronRight;

    return (
        <div className="row">
            <div className="col-sm-12">
                <div className="row checklist-header-title">
                { readOnly ? 
                    <ul className="list-inline clearfix">
                        <li className="pull-left"><button className="btn btn-basic" onClick={() => onExpandedChange(!expanded)}><FontAwesomeIcon icon={chevron}/></button></li>
                        <li><h4>{taskGroupName}</h4></li>
                    </ul>
                    :
                    <ul className="list-inline clearfix">
                        <li className="pull-left"><button className="btn btn-basic" onClick={() => onExpandedChange(!expanded)}><FontAwesomeIcon icon={chevron}/></button></li>
                        <li><h4>{taskGroupName}</h4></li>
                        <li className="pull-right checklist-task-list"><button className="btn btn-basic" onClick={() => onTaskGroupRemove(taskGroup)}><img src={`${config.WEB_BASE_URL}/images/icon/delete-trash-can.svg`} name="delete" alt={i18next.t('delete')}/></button></li>
                        <li className="pull-right"><button className="btn btn-sm btn-default" onClick={() => onAddTaskToGroup(taskGroup)}><FontAwesomeIcon icon={faPlus}/> {i18next.t('pages.checklists.task')}</button></li>
                    </ul>
                }
                </div>
            </div>
        </div>
    );
}

const ChecklistTaskGroup = ({ taskGroup, readOnly, tags, expanded, children, onTaskGroupUpdate, onAddTaskToGroup, onTaskGroupRemove }) => {
    const [groupExpanded, setGroupExpanded] = useState(expanded);

    const tagOptions = tags.map(tag => ({ value: tag.id, label: tag.name, tag: tag }));

    useEffect(() => {
        setGroupExpanded(expanded);
    }, [expanded]);

    const updateGroupName = useCallback((name) => {
        onTaskGroupUpdate({
            ...taskGroup,
            name: name
        });
    }, [taskGroup, onTaskGroupUpdate]);

    const updateGroupDescription = useCallback((description) => {
        onTaskGroupUpdate({
            ...taskGroup,
            description: description
        });
    }, [taskGroup, onTaskGroupUpdate]);

    const updateGroupTag = useCallback((option) => {
        onTaskGroupUpdate({
            ...taskGroup,
            areaTag: option.tag
        });
    }, [taskGroup, onTaskGroupUpdate]);
    
    return (
        <div className="row">
            <div className="checklist-padding">
                <div className="row checklist-config-task-container">
                    <ChecklistTaskGroupHeader 
                        readOnly={readOnly}
                        expanded={groupExpanded}
                        taskGroup={taskGroup}
                        onAddTaskToGroup={onAddTaskToGroup}
                        onTaskGroupRemove={onTaskGroupRemove}
                        onExpandedChange={setGroupExpanded}
                    />

                    { groupExpanded &&
                    <div className="checklist-padding">
                        <div className="col-sm-12">
                            <div className="row">
                                <div className="col-sm-4">
                                    <TextInput
                                        input={{
                                            value: taskGroup.name ?? '', 
                                            onChange: event => updateGroupName(event.target.value)
                                        }}
                                        type="text"
                                        label={i18next.t('form-labels.task-group-name')}
                                        readOnly={readOnly}
                                        meta={taskGroup.errors && taskGroup.errors.name ? {touched: true, error: taskGroup.errors.name} : {}}
                                    />
                                </div>
                                <div className="col-sm-4">
                                    <label>{i18next.t('form-labels.tag')}</label>
                                    <SelectInput
                                        input={{
                                            value: taskGroup.areaTag ? { label: taskGroup.areaTag.name } : null,
                                            onChange: updateGroupTag
                                        }}
                                        isDisabled={readOnly}
                                        options={tagOptions}
                                        isSearchable={true}
                                        meta={{}}
                                    />
                                </div>
                                <div className="col-sm-4">
                                    <TextInput
                                        input={{
                                            value: taskGroup.description ?? '', 
                                            onChange: event => updateGroupDescription(event.target.value)
                                        }}
                                        type="text"
                                        label={i18next.t('form-labels.description-optional')}
                                        readOnly={readOnly}
                                        meta={{}}
                                    />
                                </div>
                            </div>
                            <hr style={{paddingBottom: '15px'}}/>
                        </div>

                        <React.Fragment>
                            {children}
                        </React.Fragment>
                    </div>}
                </div>
            </div>
        </div>        
    );
}

export default ChecklistTaskGroup;